import { channelType } from "./transformer";

export const sendTiktokCode = (payload) => {
    return {
        type: `${channelType}.SEND_CODE`,
        payload: payload
    };
};
